import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentsListingComponent } from './components/agents-listing/agents-listing.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NewAgentDetailsComponent } from './components/new-agent/new-agent-details/new-agent-details.component';
import { NewAgentComponent } from './components/new-agent/new-agent.component';
import { NewAgentPortfolioComponent } from './components/new-agent/new-agent-portfolio/new-agent-portfolio.component';
import { NewAgentCatalogsComponent } from './components/new-agent/new-agent-catalogs/new-agent-catalogs.component';
import { AgentDetailsComponent } from './components/agent-details/agent-details.component';
import { AgentOrdersComponent } from './components/agent-details/agent-orders/agent-orders.component';
import { AgentPortfolioComponent } from './components/agent-details/agent-portfolio/agent-portfolio.component';
import { AgentCatalogsComponent } from './components/agent-details/agent-catalogs/agent-catalogs.component';
import { AgentInformationsComponent } from './components/agent-details/agent-informations/agent-informations.component';
import { AgentInformationsEditDialogComponent } from './components/agent-details/agent-informations/agent-informations-edit-dialog/agent-informations-edit-dialog.component';
import { UiModule } from 'src/app/ui/ui.module';
import { AgentPortfolioAddDialogComponent } from './components/agent-details/agent-portfolio/agent-portfolio-add-dialog/agent-portfolio-add-dialog.component';
import { AgentCompaniesListComponent } from './components/agent-details/agent-portfolio/agent-companies-list/agent-companies-list.component';
import { AgentCatalogsListComponent } from './components/agent-details/agent-catalogs/agent-catalogs-list/agent-catalogs-list.component';
import { AgentCatalogsAddDialogComponent } from './components/agent-details/agent-catalogs/agent-catalogs-add-dialog/agent-catalogs-add-dialog.component';
import { AgentProductPreferencesDialogComponent } from './components/agent-details/agent-catalogs/agent-product-preferences-dialog/agent-product-preferences-dialog.component';
import { NewCommissionComponent } from './components/commissions/new-commission/new-commission.component';
import { AgentsPageComponent } from './components/agents-page/agents-page.component';
import { CommissionsListingComponent } from './components/commissions/commissions-listing/commissions-listing.component';
import { NewCommissionDetailsComponent } from './components/commissions/new-commission/new-commission-details/new-commission-details.component';
import { NewCommissionThresholdsComponent } from './components/commissions/new-commission/new-commission-thresholds/new-commission-thresholds.component';
import { NewCommissionNegotiationComponent } from './components/commissions/new-commission/new-commission-negotiation/new-commission-negotiation.component';
import { NewCommissionSummaryComponent } from './components/commissions/new-commission/new-commission-summary/new-commission-summary.component';
import { CommissionDetailsComponent } from './components/commissions/commission-details/commission-details.component';
import { CommissionSettingsComponent } from './components/commissions/commission-details/commission-settings/commission-settings.component';
import { CommissionAgentsComponent } from './components/commissions/commission-details/commission-agents/commission-agents.component';
import { CommissionThresholdsComponent } from './components/commissions/commission-details/commission-thresholds/commission-thresholds.component';
import { CommissionNegotiationComponent } from './components/commissions/commission-details/commission-negotiation/commission-negotiation.component';
import { CommissionComfirmationDialogComponent } from './components/commissions/commission-details/commission-comfirmation-dialog/commission-comfirmation-dialog.component';
import { AgentsFilterComponent } from './components/agents-filter/agents-filter.component';



@NgModule({
  declarations: [
    AgentsListingComponent,
    NewAgentDetailsComponent,
    NewAgentComponent,
    NewAgentPortfolioComponent,
    NewAgentCatalogsComponent,
    AgentDetailsComponent,
    AgentOrdersComponent,
    AgentPortfolioComponent,
    AgentCatalogsComponent,
    AgentInformationsComponent,
    AgentInformationsEditDialogComponent,
    AgentPortfolioAddDialogComponent,
    AgentCatalogsListComponent,
    AgentCatalogsAddDialogComponent,
    AgentProductPreferencesDialogComponent,
    NewCommissionComponent,
    AgentsPageComponent,
    CommissionsListingComponent,
    NewCommissionDetailsComponent,
    NewCommissionThresholdsComponent,
    NewCommissionNegotiationComponent,
    NewCommissionSummaryComponent,
    CommissionDetailsComponent,
    CommissionSettingsComponent,
    CommissionAgentsComponent,
    CommissionThresholdsComponent,
    CommissionNegotiationComponent,
    CommissionComfirmationDialogComponent,
    AgentsFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule
  ]
})
export class AgentsModule { }
